export default async function ({ $auth, redirect, route, store, app, res, req }) {
  // isNewAuth 參數為 true 時，代表使用新版驗證方式
  const { appAuth, isNewAuth, appVersion } = route.query

  // 根據網址判斷是否有 appVersion 參數
  if (appVersion !== undefined) {
    store.commit('setAppNativeVersion', appVersion)
  }

  try {
    // 設定 app 狀態 cookie
    // 如果參數為 ?appAuth 或 ?appAuth=appMode，單純設定 isApp cookie (不進行登入或登出)
    if (process.server && res && typeof appAuth !== 'undefined') {
      // 獲取現有的 cookie，避免覆蓋其他 cookie
      const existingCookies = res.getHeader('Set-Cookie') || []
      const cookieArray = Array.isArray(existingCookies) ? existingCookies : [existingCookies].filter(Boolean)
      cookieArray.push('isApp=1; Path=/; Max-Age=2147483647') // 盡可能長的過期時間
      res.setHeader('Set-Cookie', cookieArray)
    }

    // 如果 appAuth 不等於 'appMode'，代表傳入 token，使用 token 登入
    if (appAuth && appAuth !== 'appMode') {
      if (isNewAuth !== 'true') {
        // 舊版驗證方式
        return await $auth.setUserToken(appAuth)
      }

      // 新版驗證方式
      // 短token換取長token
      const { Data } = await app.$axios.$post(`/api/Authentication/ECToken/Exchange?oneTimeCode=${encodeURIComponent(appAuth)}`)
      const { AccessToken, RefreshToken } = Data

      // 將 EC token 設定到 $auth
      await $auth.setUserToken(AccessToken)
      $auth.$storage.setUniversal('refresh_token', RefreshToken)
    }

    // 如果 appAuth 是空字串，代表登出
    if (appAuth === '') {
      await store.dispatch('logOut')
    }
  } catch (err) {
    $auth.$storage.removeUniversal('refresh_token') // 移除 refresh_token
    if (err?.response?.data === '該登入代碼已被使用') {
      return // 暫時阻止重複打token問題
    }
    redirect(`/auth/login?redirect=${route.path}`)
  }
}
